import React, {Component} from 'react'
import './assets-static/stylesheets/theme.css';
import {connect} from "react-redux";
import {loadApplicationData, saveApplicationData} from "./actions/ApplicationAction";
        import EQ_1_1 from "./components/EQ-1.1";
        import EQ_3_2 from "./components/EQ-3.2";
        import EQ_4_1 from "./components/EQ-4.1";
        import EQ_5_1 from "./components/EQ-5.1";
        import EQ_6_1 from "./components/EQ-6.1";
        import EQ_7_1 from "./components/EQ-7.1";
        import EQ_7_2 from "./components/EQ-7.2";
        import EQ_7_3 from "./components/EQ-7.3";
        import EQ_1_2 from "./components/EQ-1.2";
        import EQ_1_3 from "./components/EQ-1.3";
        import EQ_1_4 from "./components/EQ-1.4";
        import EQ_8_1 from "./components/EQ-8.1";
        import EQ_8_3 from "./components/EQ-8.3";
        import EQ_8_2 from "./components/EQ-8.2";
        import EQ_2_1 from "./components/EQ-2.1";
        import EQ_2_2 from "./components/EQ-2.2";
        import EQ_2_3 from "./components/EQ-2.3";
        import EQ_3_1 from "./components/EQ-3.1";
    import { BrowserRouter, Route, Switch } from 'react-router-dom';

class EQ extends Component {
constructor(props) {
super(props);
}

render() {
return (
<div>
    {this.props.application != undefined && this.props.application.applicationData != undefined &&
        <BrowserRouter>
            <Switch>
                                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-1.1">
                            <EQ_1_1 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-3.2">
                            <EQ_3_2 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-4.1">
                            <EQ_4_1 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-5.1">
                            <EQ_5_1 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-6.1">
                            <EQ_6_1 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.1">
                            <EQ_7_1 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.2">
                            <EQ_7_2 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.3">
                            <EQ_7_3 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-1.2">
                            <EQ_1_2 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-1.3">
                            <EQ_1_3 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-1.4">
                            <EQ_1_4 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-8.1">
                            <EQ_8_1 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-8.3">
                            <EQ_8_3 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-8.2">
                            <EQ_8_2 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-2.1">
                            <EQ_2_1 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-2.2">
                            <EQ_2_2 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-2.3">
                            <EQ_2_3 />
                        </Route>
                                            <Route path="/mxcitizenship/interactions/eq/users/0/applications/0/pages/EQ-3.1">
                            <EQ_3_1 />
                        </Route>
                                                </Switch>
        </BrowserRouter>
    }
</div>)
}
}

const mapDispatchToProps = (dispatch) => {
loadApplicationData("mxcitizenship").then((data) => {
return {
application: dispatch(data).payload
}
})
return dispatch(saveApplicationData({}))
};

const mapStateToProps = state => {
return {
application: state.application
}
};

export default connect(mapStateToProps, mapDispatchToProps)(EQ)
